module.exports = __webpack_public_path__ + "static/media/Kurz.42f58d3d.png";